<script>
import baseList from "@/views/components/base/baseList.vue";
import { Button } from "view-design";
export default {
  extends: baseList,
  components: {},
  data() {
    return {
      table: {
        mname: "useraccount",
        key: "id",
        url: {},
        output: false,
        order: "sort asc, create_time desc",
      },
      actions: [],
      tactions: [
        // { label: '导出数据', type: 'success', onClick: this.exportData.bind(this, '商家数据', 0), auth: '/admin/spot/lists' },
        // { label: '导出全部数据', type: 'error', onClick: this.exportData.bind(this, '商家数据', 1), auth: '/admin/spot/lists' },
      ],
      menus: [
        {
          label: "用户列表",
          name: "user_list",
          auth: "/admin/user/lists",
        },
        {
          label: "浏览记录",
          name: "record_list",
          auth: "/admin/record/lists",
        },
      ],
      query: {
      },
      filters: [
        {label: '手机号', name: 'user_mobile', value: '', type: 'input'},
        // {
        //   label: "类型",
        //   name: "from_type",
        //   value: 1,
        //   type: "select",
        //   dropList: [
        //     { value: 1, name: "平台赋予" },
        //     { value: 2, name: "兑换商品" },
        //     // { value: 3, name: "兑换充电卡" },
        //     { value: 4, name: "上门回收" },
        //     { value: 5, name: "建言献策" },
        //     // { value: 6, name: "充值" },
        //     { value: 51, name: "平台赋予退回" },
        //     { value: 52, name: "兑换商品退回" },
        //     { value: 99, name: "调整" },
        //   ],
        // },
        ],
      tableCols: [
        {
          title: "记录编号",
          key: "id",
          width: 100,
          align: "center",
        },
        {
          title: "用户手机号",
          minWidth: 120,
          key: "user_mobile",
          align: "left",
        },
        {
          title: "用户备注",
          key: "remark",
          minWidth: 120,
          align: "center",
        },
        {
          title: "类型",
          minWidth: 120,
          key: "type_name",
          align: "left",
        },
        {
          title: "访问内容",
          key: "text",
          minWidth: 120,
          align: "center",
        },
        {
          title: "访问时间",
          align: "center",
          key: "create_time",
          minWidth: 170,
        },
      ],
    };
  },
  created() {
    let query = this.$route.query;
    // 设置查询参数
    this.query.uid = query.kv;
  },
  methods: {},
};
</script>
